export const GROWINTEL_BASE_PATH = '/grow-intel';

export const GROWINTEL_PATHS = {
  ROOT: `${GROWINTEL_BASE_PATH}`,
  TRENDS: `${GROWINTEL_BASE_PATH}/trends`,
  COMPARE: `${GROWINTEL_BASE_PATH}/compare`,
  WATCHLIST: `${GROWINTEL_BASE_PATH}/watchlist`,
  SEARCH: `${GROWINTEL_BASE_PATH}/search`,
  AI: `${GROWINTEL_BASE_PATH}/ai`,
  PROFILE: `${GROWINTEL_BASE_PATH}/profile`,
  DETAIL: {
    RESTAURANT: `${GROWINTEL_BASE_PATH}/branch/:id`,
    BRAND: `${GROWINTEL_BASE_PATH}/brand/:id`,
  },
};
